<template>
  <Content is-fin />
</template>
<script route="/account/management">
  import Content from '@/views/fin/account_management/Content.jsx'
  export default {
    components: {
      Content
    }   
  }
</script>